
import { useEffect, useState } from "react";

import { FilledButton, OutlinedButton } from "../../common/Button";


import useCurrentUser from "../../../hooks/useCurrentUser";
import { IFreelancer } from "../../../data_models/freelancer";
import Lightbox from "../../common/Lightbox";
import TextInputField from "../../common/TextInputField";

import { checkDateFormat, checkPhoneNumber } from "../../../utils/regularExpressions";
import { OutlinedDropdownMenu } from "../../common/DropdownMenu";
import { getStringEnumValues } from "../../../utils/enumUtils";
import { ECountry, countriesToTextMapper } from "../../../data_models/data/countries";
import MultiTextSelect from "../../common/MultiTextSelect";
import { dateToFormatString } from "../../../utils/dateUtils";


interface EditLegalAndTaxFreelancerProps {
    onClose: () => void;
}

export const EditLegalAndTaxFreelancer: React.FC<EditLegalAndTaxFreelancerProps> = ({ onClose }) => {

    const [loading, setLoading] = useState(false);
    const { currentUser, updateCurrentUser } = useCurrentUser();

    const [fullLegalName, setFullLegalName] = useState((currentUser as IFreelancer).fullLegalName || '');
    const [businessName, setBusinessName] = useState((currentUser as IFreelancer).businessName || '');
    const [taxId, setTaxId] = useState((currentUser as IFreelancer).taxId || '');
    const [exemptPayeeCode, setExemptPayeeCode] = useState((currentUser as IFreelancer).exemptPayeeCode || '');
    const [exemptionFromFatcaReportingCode, setExemptionFromFatcaReportingCode] = useState((currentUser as IFreelancer).exemptionFromFatcaReportingCode || '');




    const checkIfValid = () => {
        let valid = true;

        return valid;
    }

    const onSubmit = async () => {

        const valid = checkIfValid();
        if (!valid) return;

        setLoading(true);

        try {

            const updateObj: IFreelancer = {
                fullLegalName: fullLegalName,
                businessName: businessName,
                taxId: taxId,
                exemptPayeeCode: exemptPayeeCode,
                exemptionFromFatcaReportingCode: exemptionFromFatcaReportingCode,
            }
            await updateCurrentUser(updateObj);
        } catch (error: any) {
        } finally {
            setLoading(false);
            onClose();
        }
    }

    return (
        <Lightbox
            content={
                <div className="flex flex-col space-y-6 w-full" >
                    <h4>Update Personal Information</h4>
                    <p>The following fields are only for legal or technical purposes and won't be shared with other users.</p>
                    {/* Full Legal Name */}
                    <TextInputField
                        type="text"
                        id="fullLegalName"
                        label="Full Legal Name"
                        placeholder="Full legal name"
                        value={fullLegalName}
                        onChange={(e) => setFullLegalName(e.target.value)}
                    />

                    {/* Business Name */}
                    <TextInputField
                        type="text"
                        id="businessName"
                        label="Business Name (optional)"
                        placeholder="Business Name under which you operate"
                        value={businessName}
                        onChange={(e) => setBusinessName(e.target.value)}
                    />

                    {/* Tax Id */}
                    <TextInputField
                        type="text"
                        id="taxId"
                        label="Tax Id"
                        placeholder="Tax Id"
                        value={taxId}
                        onChange={(e) => setTaxId(e.target.value)}
                    />

                    {/* Expemption Payee Code */}
                    <TextInputField
                        type="text"
                        id="exemptPayeeCode"
                        label="Exemption Payee Code"
                        placeholder="Exemption Payee Code"
                        value={exemptPayeeCode}
                        onChange={(e) => setExemptPayeeCode(e.target.value)}
                    />

                    {/* Exepmtion from Fatca */}
                    <TextInputField
                        type="text"
                        id="exemptionFromFatcaReportingCode"
                        label="Exemption from Fatca Reporting Code"
                        placeholder="Exemption from Fatca Reporting Code"
                        value={exemptionFromFatcaReportingCode}
                        onChange={(e) => setExemptionFromFatcaReportingCode(e.target.value)}
                    />

                    <div className="flex flex-row justify-end w-full space-x-2">

                        <OutlinedButton onClick={onClose}>Cancel</OutlinedButton>
                        <FilledButton
                            isLoading={loading}
                            onClick={onSubmit}>Submit</FilledButton>
                    </div>
                </div>}
            onClose={onClose}
        />

    );
}

